import { Extension } from "@tiptap/core";
import { Plugin, TextSelection } from "@tiptap/pm/state";
import type { EditorView } from "@tiptap/pm/view";
import { BRACKET_CLOSING_CHARS, BRACKET_OPEN_TO_CLOSE } from "./bracket-utils";

/**
 * When the user types an opening bracket with a collapsed selection,
 * inserts the matching closing bracket and leaves the caret between them.
 * When the user types a closing bracket and the next character is already that
 * closer (from auto-close), moves the caret past it instead of inserting again.
 */
const AutoCloseBrackets = Extension.create({
  name: "autoCloseBrackets",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleTextInput(
            view: EditorView,
            from: number,
            to: number,
            text: string,
          ) {
            if (from !== to) return false;
            if (text.length !== 1) return false;

            const { state } = view;
            const pairClose = BRACKET_OPEN_TO_CLOSE[text];
            if (pairClose) {
              const tr = state.tr.insertText(text + pairClose, from, to);
              tr.setSelection(TextSelection.create(tr.doc, from + 1));
              view.dispatch(tr);
              return true;
            }

            if (BRACKET_CLOSING_CHARS.has(text)) {
              const docSize = state.doc.content.size;
              if (from < docSize) {
                const nextChar = state.doc.textBetween(
                  from,
                  from + 1,
                  "",
                  "\ufffc",
                );
                if (nextChar === text) {
                  const tr = state.tr.setSelection(
                    TextSelection.create(state.doc, from + 1),
                  );
                  view.dispatch(tr);
                  return true;
                }
              }
            }

            return false;
          },
        },
      }),
    ];
  },
});

export default AutoCloseBrackets;
